import { render, staticRenderFns } from "./shopGoodsPurchase.vue?vue&type=template&id=c688add6&scoped=true"
import script from "./shopGoodsPurchase.vue?vue&type=script&lang=js"
export * from "./shopGoodsPurchase.vue?vue&type=script&lang=js"
import style0 from "./shopGoodsPurchase.vue?vue&type=style&index=0&id=c688add6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c688add6",
  null
  
)

export default component.exports